import { encryptData, decryptData } from './cryptographicOperations'; // Import the encryptData function
import Cookies from 'js-cookie';
/**
 * Saves encrypted data to localStorage.
 * @param {string} key The key under which to store the data in localStorage.
 * @param {string} data The data to encrypt and store.
 */
const saveToLocalStorage = (key, data) => {
  // Encrypt the data
  const encryptedData = encryptData(JSON.stringify(data));

  // Save the encrypted data to localStorage
  localStorage.setItem(key, encryptedData);
};

const loadFromLocalStorage = (key) => {
  // Get the encrypted data from localStorage
  const encryptedData = localStorage.getItem(key);

  // If no encrypted data is found, return null
  if (!encryptedData) return null;

  // Decrypt the encrypted data
  const decryptedData = decryptData(encryptedData);

  return decryptedData;
};

/**
 * Saves encrypted data to Cookies.
 * @param {string} key The key under which to store the data in Cookies.
 * @param {string} data The data to encrypt and store.
 */
const saveToCookieStorage = (key, data) => {
  // Encrypt the data
  const encryptedData = encryptData(data);

  // Save the encrypted data to Cookies
  localStorage.setItem(key, encryptedData);
  Cookies.set(key, encryptedData);
};

const loadFromCookieStorage = (key) => {
  // Get the encrypted data from localStorage
  const encryptedData = Cookies.get(key);

  // If no encrypted data is found, return null
  if (!encryptedData) return null;

  // Decrypt the encrypted data
  const decryptedData = decryptData(encryptedData);

  return decryptedData;
};

export { saveToLocalStorage, loadFromLocalStorage, saveToCookieStorage, loadFromCookieStorage };
